import React, { useEffect } from "react";
import TypingAnimation from "../TypingAnimation";
import { ConversationStep } from "../../interfaces";
import { sendNewLead } from "../../util";
import { useAppDispatch } from "../../store/hooks";
import { trackEvent } from "../../store/analytics/action";

interface IProps {
  values?: any;
  step?: ConversationStep;
  triggerNextStep?: (data?: {
    currentStep: ConversationStep;
    value?: string | number;
    trigger: string;
  }) => void;
}

const SendNewLead: React.FC<IProps> = ({ values, step, triggerNextStep }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initialize = async () => {
      await sendNewLead(values, step?.theme!);

      if (
        values?.talk_with_advisor === "Yes" &&
        step?.theme?.apiKey === "14b659e9-b757-49ee-9756-6cd1be0a0763"
      ) {
        window.open(step?.theme?.links?.calendarURL, "_blank");
      }

      dispatch(
        trackEvent({
          lead: values,
        })
      );

      triggerNextStep!({
        currentStep: step!,
        trigger: step!.trigger,
      });
    };

    initialize();
    /*eslint-disable react-hooks/exhaustive-deps*/
  }, []);

  if (
    values?.talk_with_advisor === "No" &&
    values?.theme?.apiKey === "d6176c89-bca5-4454-9101-20f15203dc87"
  ) {
    return null;
  }

  if (
    values?.talk_with_advisor === "Yes" &&
    step?.theme?.apiKey === "14b659e9-b757-49ee-9756-6cd1be0a0763"
  ) {
    return null;
  }

  return (
    step?.id === "select_date_sendnewlead" ||
    step?.id === "loading_illustration_sendnewlead" ||
    step?.id === "insurance_quote_sendnewlead" ? null :
    <>
      {step?.id !== "blank_send" && (
        <div className="conversation-message-bubble">
          <TypingAnimation theme={step?.theme!} type="bot" />
          <div className="conversation-message-bubble-text">
            No Problem
            {/* No problem.{" "} */}
            {step?.theme?.apiKey === "31866677-e315-4465-bbe2-07582d725823"
              ? "Have a great day."
              : ""}
          </div>
        </div>
      )}
      {step?.id === "blank_send" &&
        step?.theme?.apiKey === "911997a2-825f-479c-ac80-b8a15a5f7e36" && (
          <div className="conversation-message-bubble">
            <TypingAnimation theme={step?.theme!} type="bot" />
            <div className="conversation-message-bubble-text">
              Great, we will confirm with you shortly
            </div>
          </div>
        )}
    </>
  );
};

export default React.memo(SendNewLead);
